/** Assinatura WhatsApp: *Nome* ou *Nome*:\n no início da mensagem */
const SIGNATURE_PATTERN = /^\*([^*\n]+)\*(?::\s*)?\n?/;

/** Remove a assinatura do atendente para edição/exibição no input */
export function stripMessageSignature(text: string): string {
    if (!text) return text;
    return text.replace(SIGNATURE_PATTERN, '').trimStart();
}

/** Corpo editável da mensagem (sem assinatura do atendente). */
export function getEditableMessageBody(text?: string | null): string {
    if (!text) return '';
    return stripMessageSignature(text).trim();
}

export function hasMessageSignature(text: string): boolean {
    return SIGNATURE_PATTERN.test(text);
}

/**
 * Garante `\n` entre assinatura e corpo (*Nome* Teste → *Nome*\nTeste).
 * Usado em quote/reply preview para o corpo não ficar na mesma linha.
 */
export function ensureSignatureLineBreak(text: string): string {
    if (!text) return text;
    const match = text.match(SIGNATURE_PATTERN);
    if (!match) return text;
    const body = stripMessageSignature(text);
    if (!body) return `*${match[1]}*`;
    return `*${match[1]}*\n${body}`;
}

/** Monta texto com assinatura (formato WhatsApp markdown) */
export function buildSignedMessage(signatureName: string, body: string): string {
    const cleanName = signatureName.trim().replace(/:+$/, '');
    if (!cleanName) return body;
    const prefix = `*${cleanName}*\n`;
    if (body.startsWith(`*${cleanName}`)) return body;
    return `${prefix}${body}`;
}
